module.exports = __webpack_public_path__ + "img/boy_010008.bc96bea8.png";